import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css"; // Import AOS styles
import { useTheme } from "../../context/ThemeContext";

const Experience_one = () => {

    const { theme } = useTheme();


    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration (in ms)
            once: false, // Whether animation should happen only once
        });
    }, []);

    const experiences = [
        {
            company: "Luxury Data Cove",
            period: "October 2023 - Present",
            position: "Cloud Architect",
            type: "Part-Time",
            tasks: [
                "Design & implement cloud solutions as DevOps engineer.",
                "Architect and develop scalable full-stack applications.",
            ],
        },
        {
            company: "Ace Academy",
            period: "June 2023 - August 2023 (2 months)",
            position: "Cybersecurity Mentor",
            type: "Part-Time",
            tasks: [
                "Instruct courses on Linux and UNIX operating systems.",
                "Mentor students in cybersecurity best practices and tools.",
            ],
        },
        {
            company: "Artisante - Fine Foods",
            period: "August 2022 - January 2023 (6 months)",
            position: "Full-Stack Developer",
            type: "Freelance",
            tasks: [
                "Developed full-stack applications to enhance online presence.",
                "Created intuitive UI/UX designs for optimal user engagement.",
            ],
        },
        {
            company: "Tartine Bakery",
            period: "October 2021 - February 2022 (5 months)",
            position: "Full-Stack Developer",
            type: "Freelance",
            tasks: [
                "Developed scalable front-end and back-end software solutions.",
                "Managed database and API integration for seamless performance.",
            ],
        },
    ];

    return (
        <>
            <div className="container shadow rounded-lg mx-auto lg:p-5 md:p-5 p-1">
                <h2 className="text-3xl font-bold text-left mb-5 p-5">
                    Experiences
                </h2>

                {/* Desktop Timeline */}
                <ul className="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical hidden lg:block md:block">
                    {experiences.map((exp, index) => (
                        <li
                            key={index}
                            data-aos={
                                index % 2 === 0
                                    ? "zoom-in-right"
                                    : "zoom-in-left"
                            }
                            className="mb-2"
                        >
                            <div className="timeline-middle" data-aos="zoom-in">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="32"
                                    height="32"
                                    fill="currentColor"
                                >
                                    <path d="M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 11.9435 5.66627 14.533 8.64514 16.9029C9.39 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038Z"></path>
                                </svg>
                            </div>
                            <div
                                className={`${
                                    index % 2 === 0
                                        ? "timeline-start text-right"
                                        : "timeline-end text-left"
                                }`}
                            >
                                <time
                                    className="font-mono italic"
                                    data-aos="fade-down"
                                >
                                    {exp.period}
                                </time>
                                <div
                                    className="text-lg font-black"
                                    data-aos="fade-right"
                                >
                                    {exp.company}
                                </div>
                                <h4
                                    className="text-md font-semibold"
                                    data-aos="fade-in-up"
                                >
                                    {exp.position}
                                </h4>
                                <p
                                    className="text-gray-500"
                                    data-aos="fade-left"
                                >
                                    {exp.type}
                                </p>
                                <ul
                                    className="list-disc list-inside"
                                    data-aos="zoom-in"
                                >
                                    {exp.tasks.map((task, taskIndex) => (
                                        <li key={taskIndex}>{task}</li>
                                    ))}
                                </ul>
                            </div>

                            {index < experiences.length && <hr className={`h-1 ${theme === 'light' ? 'bg-black' : 'bg-white'}`}  />}
                        </li>
                    ))}
                </ul>

                {/* Mobile Timeline */}
                <ul className="timeline timeline-snap-icon max-md:timeline-compact timeline-vertical lg:hidden md:hidden">
                    {experiences.map((exp, index) => (
                        <li key={index} className="mb-1">
                            <div className="timeline-middle">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    width="32"
                                    height="32"
                                    fill="currentColor"
                                >
                                    <path d="M16.5 3C19.5376 3 22 5.5 22 9C22 16 14.5 20 12 21.5C9.5 20 2 16 2 9C2 5.5 4.5 3 7.5 3C9.35997 3 11 4 12 5C13 4 14.64 3 16.5 3ZM12.9339 18.6038C13.8155 18.0485 14.61 17.4955 15.3549 16.9029C18.3337 14.533 20 11.9435 20 9C20 6.64076 18.463 5 16.5 5C15.4241 5 14.2593 5.56911 13.4142 6.41421L12 7.82843L10.5858 6.41421C9.74068 5.56911 8.5759 5 7.5 5C5.55906 5 4 6.6565 4 9C4 11.9435 5.66627 14.533 8.64514 16.9029C9.39 17.4955 10.1845 18.0485 11.0661 18.6038C11.3646 18.7919 11.6611 18.9729 12 19.1752C12.3389 18.9729 12.6354 18.7919 12.9339 18.6038Z"></path>
                                </svg>
                            </div>
                            <div className="timeline-end text-left">
                                <time
                                    className="font-mono italic"
                                    data-aos="zoom-in"
                                >
                                    {exp.period}
                                </time>
                                <div
                                    className="text-lg font-black"
                                    data-aos="zoom-in"
                                >
                                    {exp.company}
                                </div>
                                <h4
                                    className="text-md font-semibold"
                                    data-aos="zoom-in"
                                >
                                    {exp.position}
                                </h4>
                                <p className="text-gray-500" data-aos="zoom-in">
                                    {exp.type}
                                </p>
                                <ul
                                    className="list-disc list-inside"
                                    data-aos="zoom-in"
                                >
                                    {exp.tasks.map((task, taskIndex) => (
                                        <li key={taskIndex} data-aos="zoom-in">
                                            {task}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            {index < experiences.length && <hr className={`h-1 ${theme === 'light' ? 'bg-black' : 'bg-white'}`}  />}
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default Experience_one;
